export default function computeCommentElementID(commentID: string) {
  return `comment-${commentID}`;
}
